import { render, staticRenderFns } from "./ClassifiedAdList.vue?vue&type=template&id=8ca50e1a&"
import script from "./ClassifiedAdList.vue?vue&type=script&lang=js&"
export * from "./ClassifiedAdList.vue?vue&type=script&lang=js&"
import style0 from "./ClassifiedAdList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports